import React from 'react';
import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';

import * as ds from './dataService';

export type RemoveMaterialDeliveryModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveMaterialDeliveryModalProps) => {
  const [
    fnRemoveDelivery,
    { loading }
  ] = ds.useRemoveDeliveryModal();

  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title='Remove Delivery'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      subTitle='Are you sure to remove this delivery? This action cannot be undone.'
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnRemoveDelivery(props.id);
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );
};
